/* eslint-disable import/default, no-console */
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store.prod');
} else {
  console.log(`Running in ${process.env.NODE_ENV} mode`);
  module.exports = require('./store.dev');
}



// WEBPACK FOOTER //
// ./src/store/index.js